import { jsx as _jsx } from "react/jsx-runtime";
import { VideoEmbedWidgetRenderer } from '@app/dashboard/biolink/biolink-editor/content/widgets/video-embed-widget-renderer';
export function SoundcloudWidgetRenderer({ widget, variant, }) {
    if (!widget.config.url)
        return null;
    return (_jsx(VideoEmbedWidgetRenderer, { variant: variant, embedUrl: widget.config.embedUrl }));
}
